import React, { useId } from 'react';

/**
 * Animated "electric" border using an SVG turbulent-displace filter.
 * Renders as an absolute overlay; place inside a `position: relative` parent.
 */
const ElectricBorder = ({ color = '#dd8448', radius = 0, className = '' }) => {
  const rawId = useId();
  const filterId = `eb-filter-${rawId.replace(/[:]/g, '')}`;

  return (
    <div
      className={`eb-wrap ${className}`}
      style={{ '--eb-color': color, '--eb-radius': `${radius}px` }}
    >
      <svg className="eb-svg" aria-hidden="true">
        <defs>
          <filter
            id={filterId}
            colorInterpolationFilters="sRGB"
            x="-20%"
            y="-20%"
            width="140%"
            height="140%"
          >
            <feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise1" seed="1" />
            <feOffset in="noise1" dx="0" dy="0" result="offsetNoise1">
              <animate attributeName="dy" values="700; 0" dur="6s" repeatCount="indefinite" calcMode="linear" />
            </feOffset>

            <feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise2" seed="1" />
            <feOffset in="noise2" dx="0" dy="0" result="offsetNoise2">
              <animate attributeName="dy" values="0; -700" dur="6s" repeatCount="indefinite" calcMode="linear" />
            </feOffset>

            <feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise3" seed="2" />
            <feOffset in="noise3" dx="0" dy="0" result="offsetNoise3">
              <animate attributeName="dx" values="490; 0" dur="6s" repeatCount="indefinite" calcMode="linear" />
            </feOffset>

            <feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="10" result="noise4" seed="2" />
            <feOffset in="noise4" dx="0" dy="0" result="offsetNoise4">
              <animate attributeName="dx" values="0; -490" dur="6s" repeatCount="indefinite" calcMode="linear" />
            </feOffset>

            <feComposite in="offsetNoise1" in2="offsetNoise2" result="part1" />
            <feComposite in="offsetNoise3" in2="offsetNoise4" result="part2" />
            <feBlend in="part1" in2="part2" mode="color-dodge" result="combinedNoise" />
            <feDisplacementMap
              in="SourceGraphic"
              in2="combinedNoise"
              scale="18"
              xChannelSelector="R"
              yChannelSelector="B"
            />
          </filter>
        </defs>
      </svg>

      <div className="eb-layers">
        <div className="eb-stroke" style={{ filter: `url(#${filterId})` }} />
        <div className="eb-glow1" style={{ filter: `blur(3px) url(#${filterId})` }} />
        <div className="eb-glow2" style={{ filter: `blur(9px) url(#${filterId})` }} />
        <div className="eb-bg" />
      </div>
    </div>
  );
};

export default ElectricBorder;
